import { useSyncExternalStore } from 'react';
import { ConnectivitySnapshot, getConnectivity, subscribeConnectivity } from '../services/connectivity';

/** The app-wide connectivity state (see services/connectivity). */
export function useConnectivity(): ConnectivitySnapshot {
  return useSyncExternalStore(subscribeConnectivity, getConnectivity);
}

/** Convenience: true only when the API is answering. */
export function useIsOnline(): boolean {
  return useConnectivity().status === 'online';
}

/**
 * Tooltip for an action disabled because the API can't be reached, or
 * undefined when online (so callers can fall back to their usual title).
 */
export function useOfflineActionTitle(): string | undefined {
  const { status } = useConnectivity();
  if (status === 'offline') return "You're offline — reconnect to do this";
  if (status === 'unreachable') return "Can't reach the server — try again once it's back";
  return undefined;
}
